import Section from './SliderImageBlock'
import isEmpty from './SliderImageIsEmpty'
import Options from './SliderImageOptions'

export default { isEmpty, Section, Options }
